import React from "react";
import FilterHeader, { type SortOption } from "@/components/contatos/FilterHeader";
import ContactsTable from "@/components/contatos/ContactsTable";
import { useAuth } from "@/contexts/AuthContext";
import { useState } from "react";
import type { ContactFilters } from "@/components/ui/shared/MoreFilter";

const Contacts: React.FC = () => {
  const { user } = useAuth();
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState<SortOption>("created_desc");
  const [filters, setFilters] = useState<ContactFilters>({
    assistantId: null,
    attributionId: null,
    tags: [],
    campaigns: [],
    dateFrom: null,
    dateTo: null,
  });

  const handleFilterChange = (newFilters: ContactFilters) => {
    console.log("🔄 [Contacts] Filtros atualizados:", newFilters);
    setFilters(newFilters);
  };

  const handleClearFilters = () => {
    console.log("🧹 [Contacts] Limpando filtros");
    setFilters({
      assistantId: null,
      attributionId: null,
      tags: [],
      campaigns: [],
      dateFrom: null,
      dateTo: null,
    });
  };

  const handleSortChange = (newSort: SortOption) => {
    console.log("🔄 [Contacts] Ordenação atualizada:", newSort);
    setSortBy(newSort);
  };

  console.log("📄 [Contacts Page] Renderizando página de contatos");
  console.log("👤 [Contacts Page] Usuário logado:", {
    user_id: user?.id,
    user_name: user?.name,
    user_email: user?.email,
    account_id: user?.account_id,
    profile: user?.profile,
  });

  return (
    <div className="w-full flex h-[calc(100dvh-110px)] flex-col gap-6">
      <h1 className="text-[34px] sm:text-[36px] leading-tight font-bold text-foreground tracking-tight">
        Contatos
      </h1>

      <FilterHeader
        onSearchChange={setSearchTerm}
        searchTerm={searchTerm}
        currentFilters={filters}
        onFilterChange={handleFilterChange}
        onClearFilters={handleClearFilters}
        sortBy={sortBy}
        onSortChange={handleSortChange}
      />

      <ContactsTable
        searchTerm={searchTerm}
        filters={filters}
        sortBy={sortBy}
      />
    </div>
  );
};

export default Contacts;
